import http from '@/assets/plugin/prototypes/modules/http.js'

export function loginByMobile(data) {
    return http.post("loginByMobile", data)
}

export function loginByPassWord(data) {
    return http.post("loginByPassWord", data)
}

export function forgotPassword(data) {
    return http.post("forgotPassword", data)
}

export function register(data) {
    return http.post("register", data)
}

export function getUserInfo(data) {
    return http.post("center/detail", data)
}




// WEBPACK FOOTER //
// ./src/api/user.js